<template>
  <div class="container flex flex-col gap-8 rounded-sm bg-white px-8 py-10">
    <div class="flex flex-col gap-9">
      <slot name="switch" />
      <div class="flex justify-start gap-10">
        <slot name="trip-type" />
      </div>
      <section
        class="grid gap-4 md:grid-cols-[1fr_324px] lg:grid-cols-[66%_33%] xl:grid-cols-[1fr_420px]"
        :aria-label="$t('fsf.flightSearchOptions')"
      >
        <OrigDest
          watch-query-params
          :show-any-destin-option="false"
        />
        <FsfPaxSelect />
      </section>

      <div>
        <slot name="tab-row" />
        <div class="flex flex-col gap-8 border border-t-0 border-border pt-6 md:px-4 md:py-6">
          <slot name="month-menu" />
          <div class="flex flex-col gap-6">
            <slot name="calendar" />
            <slot name="legends" />
          </div>
        </div>
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>
